export default __webpack_public_path__ + "static/media/Mailbox-box.6781ec5e.svg";